// extracted by mini-css-extract-plugin
export var dataCell = "_qn-2";
export var dataRow = "_qn-0";
export var headerRow = "_qn-1";